var React = require('react');

function Close (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M14.603,15.793c0.348,0.271,0.818,0.248,1.119-0.053c0.301-0.301,0.323-0.772,0.053-1.12l-0.117-0.151L9.209,8.02\n\tl6.546-6.546l0.059-0.091c0.271-0.347,0.248-0.818-0.053-1.119c-0.301-0.302-0.772-0.324-1.119-0.053l-0.19,0.148L7.999,6.81\n\tL1.432,0.24C1.108-0.063,0.58-0.057,0.252,0.27c-0.325,0.325-0.333,0.848-0.024,1.184L0.5,1.703l-0.01,0.01l6.303,6.303\n\tl-6.258,6.258l0.004,0.004L0.266,14.55c-0.144,0.155-0.225,0.36-0.225,0.578c0,0.228,0.089,0.443,0.25,0.605\n\tc0.314,0.314,0.856,0.324,1.181,0.027l0.037-0.041l0.22-0.228l0.005,0.005l6.269-6.269l6.508,6.508L14.603,15.793z"}));
}

Close.defaultProps = {"version":"1.1","id":"Ebene_1","x":"0px","y":"0px","viewBox":"0 0 16 16","style":{"enableBackground":"new 0 0 16 16"},"xmlSpace":"preserve"};

module.exports = Close;

Close.default = Close;
